import { render } from "./splitticket.vue?vue&type=template&id=31199fd4"
import script from "./splitticket.vue?vue&type=script&lang=js"
export * from "./splitticket.vue?vue&type=script&lang=js"

import "./splitticket.vue?vue&type=style&index=0&id=31199fd4&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__